export default __webpack_public_path__ + "dd4ad256a2b3b5a5732cd18e1a922a70.png";